import { defineComponent as _defineComponent } from 'vue'
import { Ref, computed, onBeforeMount, ref } from 'vue';
import { AxiosError } from 'axios';
import store from '@/store';
import { getEmail, getReferrerData, logout, setReferrer, updateUser, updateUserAffiliate } from '@/api/user';
import { CustomilyUser } from '@/typings/user';
import CCheckbox from '@/components/shared/CCheckbox.vue';
import LoaderBtn from '@/components/LoaderBtn/LoaderBtn.vue';
import EmailUpdateDialog from '@/components/EmailUpdateDialog/EmailUpdateDialog.vue';
import ChangePasswordDialog from '@/components/ChangePasswordDialog/ChangePasswordDialog.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Account',
  emits: ['user-updated'],
  setup(__props, { emit }) {

const helpc = 'https://help.customily.com/en/article/how-to-get-a-discount-by-inviting-your-friends';



const name: Ref<string | null> = ref(null);
const email: Ref<string | null> = ref(null);
const loadingEmail = ref(true);
const showEmailChangeModal = ref(false);
const showPasswordChangeModal = ref(false);
const showNameWarnModal = ref(false);
const savingName = ref(false);
const savingReferrer = ref(false);
const clipartProtection = ref(false);
const savingSecurity = ref(false);
const myReferralCode: Ref<string | null> = ref(null);
const showReferrerInput = ref(false);
const referrer = ref('');
const numberReferred = ref(0);
const showReferrerSuccess = ref(false);
const referrerEmail = ref('');
const referrerErrorMessage = ref('');
const showReferralCard = ref(false);
const savingPaypalEmail = ref(false);
const paypalEmail = ref('');
const myStampUrl = ref('');

const user = computed(() =>
    store.state.user?.ImpersonatedFromChildUser ? store.state.user?.UserImpersonatedFrom : store.state.user
);

const modifiedName = computed(() => name.value && user.value?.Name !== name.value);
const modifiedSecurity = computed(() => user.value?.SegmentLibraryImages !== clipartProtection.value);
const modifiedPaypalEmail = computed(() => user.value?.UserAffiliate?.PaypalEmail !== paypalEmail.value);

const hasAffiliate = computed(() => {
    if (user.value?.AccessRoles == null) return false;
    return user.value?.AccessRoles?.Serialized.includes('affiliate');
});

onBeforeMount(async () => {
    name.value = user.value!.Name;
    email.value = user.value!.Email;
    loadingEmail.value = false;
    clipartProtection.value = user.value!.SegmentLibraryImages;
    myReferralCode.value = user.value!.CodeForReferrals;
    referrer.value = '';
    referrerErrorMessage.value = '';
    paypalEmail.value = user.value!.UserAffiliate?.PaypalEmail || '';
    myStampUrl.value = user.value!.UserAffiliate?.StampUrl || '';

    const referrerData = await getReferrerData();
    showReferrerInput.value = user.value!.ReferredBy === null && referrerData.UserIsInTrial;
    numberReferred.value = referrerData.NumberReferred;
    referrerEmail.value = referrerData.ReferredEmail;
    showReferralCard.value = referrerData.IsShopify;
});

const onProfileSubmit = async () => {
    // For accounts that do not have a name (old account with a fixed pre-determined password) alert them that changing the name will
    //  force the to reset the password
    if (!user.value?.Name) {
        showNameWarnModal.value = true;
    } else {
        await updateUserName();
    }
};

const onSecuritySubmit = async () => {
    try {
        savingSecurity.value = true;
        const user = await updateUser(undefined, clipartProtection.value);
        updateUserState(user);
    } finally {
        savingSecurity.value = false;
    }
};

const updateUserName = async () => {
    try {
        // Save the new user name and update it in the store
        savingName.value = true;
        if (name.value) {
            const user = await updateUser(name.value);
            updateUserState(user);
        }
    } finally {
        savingName.value = false;
    }
};

const onReferrerSubmit = async () => {
    try {
        savingReferrer.value = true;
        const referrerEmail = await setReferrer(referrer.value);
        showReferrerInput.value = false;
        showReferrerSuccess.value = true;
        referrerEmail.value = referrerEmail;
        referrerErrorMessage.value = '';
    } catch (_error) {
        const error = _error as AxiosError;
        if ([400, 500].includes(error.response?.status || 0)) {
            referrerErrorMessage.value = error.response?.data.Message;
        }
    } finally {
        savingReferrer.value = false;
    }
};

const onPaypalSubmit = async () => {
    savingPaypalEmail.value = true;
    try {
        if (paypalEmail.value) {
            const user = await updateUserAffiliate(paypalEmail.value);
            updateUserState(user);
        }
    } finally {
        savingPaypalEmail.value = false;
    }
};

const onPasswordChanged = async () => {
    await logout();
    location.pathname = '/signin';
};

const updateUserState = (user: CustomilyUser) => {
    store.commit('user', user);
    emit('user-updated');
};

return { __sfc: true,helpc, emit, name, email, loadingEmail, showEmailChangeModal, showPasswordChangeModal, showNameWarnModal, savingName, savingReferrer, clipartProtection, savingSecurity, myReferralCode, showReferrerInput, referrer, numberReferred, showReferrerSuccess, referrerEmail, referrerErrorMessage, showReferralCard, savingPaypalEmail, paypalEmail, myStampUrl, user, modifiedName, modifiedSecurity, modifiedPaypalEmail, hasAffiliate, onProfileSubmit, onSecuritySubmit, updateUserName, onReferrerSubmit, onPaypalSubmit, onPasswordChanged, updateUserState, CCheckbox, LoaderBtn, EmailUpdateDialog, ChangePasswordDialog }
}

})